import React from 'react';
import Header from '../../components/Informacion/Header/Header';
import InformacionComponent from '../../components/Informacion/Informacion/Informacion';

const Informacion = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <Header />
        </div>
        <div>
            <InformacionComponent />
        </div>
      </div>
    );
  };
  
export default Informacion;

